import PropTypes from '../_util/vue-types';
import { stringType, booleanType, functionType, objectType } from '../_util/type';
export const floatButtonProps = () => {
    return {
        prefixCls: String,
        description: PropTypes.any,
        type: stringType('default'),
        shape: stringType('circle'),
        tooltip: PropTypes.any,
        href: String,
        target: String,
        badge: objectType(),
        /** Set the original html `type` of `button` (antd ≥ 5.21) */
        htmlType: stringType(),
        onClick: functionType(),
    };
};
export const floatButtonContentProps = () => {
    return {
        prefixCls: stringType(),
    };
};
export const floatButtonGroupProps = () => {
    return Object.assign(Object.assign({}, floatButtonProps()), { 
        // 包含的 Float Button
        // 触发方式 (有触发方式为菜单模式）
        trigger: stringType(), 
        // 受控展开
        open: booleanType(), 
        // 展开收起的回调
        onOpenChange: functionType(), 'onUpdate:open': functionType(), 
        /** Customize menu animation placement (antd ≥ 5.21) */
        placement: stringType(), 
        /** Customize close button icon (antd ≥ 5.16) */
        closeIcon: PropTypes.any });
};
export const backTopProps = () => {
    return Object.assign(Object.assign({}, floatButtonProps()), { prefixCls: String, duration: Number, target: functionType(), visibilityHeight: Number, onClick: functionType() });
};
